import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_invoice_branding checks
// invoice_settings.logo_url IS NOT NULL.
export async function resolveInvoiceBrandingItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_invoice_branding) return { complete: true, reason: 'logo configured' };
  return { complete: false, reason: 'no logo' };
}
